<script setup>
import { onMounted } from 'vue'
import Swal from 'sweetalert2'

definePage({
  alias: '/pages/misc/not-authorized',
  meta: {
    public: true,
  },
})

onMounted(() => {
  document.body.style.filter = 'blur(5px)'
  document.body.style.pointerEvents = 'none'

  setTimeout(() => {
    document.body.style.filter = 'none'
    document.body.style.pointerEvents = 'auto'
    
    Swal.fire({
      icon: 'error',
      title: 'Acesso Negado',
      text: 'Você não tem permissão para acessar esta funcionalidade. Retornando ao início.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      confirmButtonText: 'OK',
      backdrop: `
        rgba(0,0,10,0.6)
      `
    }).then(() => {
      window.location.href = '/'
    })
  }, 100)
})
</script>

<template>
  <div class="blank-bg">
    <div class="unauthorized-message">
       Bloqueado.
    </div>
  </div>
</template>

<style scoped>
.blank-bg {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255,255,255,0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.unauthorized-message {
  font-size: 2rem;
  color: #333;
  opacity: 0.1;
}
</style>
